import { render, staticRenderFns } from "./HospC.vue?vue&type=template&id=08f2b050&scoped=true"
import script from "./HospC.vue?vue&type=script&lang=js"
export * from "./HospC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f2b050",
  null
  
)

export default component.exports